<!-- <app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer> -->
<!-- <ngx-spinner type="ball-scale-multiple"></ngx-spinner> -->
<ng-container *ngIf="view">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <app-chatbot *ngIf="isChatbotOpen" (toggleChatbot)="toggleChatbot()"></app-chatbot>
    <div class="chatbot-toggle-btn" (click)="toggleChatbot()" [ngClass]="{'pulse': !isChatbotOpen}" aria-label="Toggle Chatbot">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-robot bot-icon" viewBox="0 0 16 16">
            <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a24.286 24.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"/>
            <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"/>
        </svg>
    </div>
</ng-container>
<ng-container *ngIf="!view">
    <router-outlet></router-outlet>
</ng-container>


<!-- Button trigger modal -->
<!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
    Launch demo modal
</button> -->

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="margin-top: 230px;">
            <div class="modal-header" style="height: 90px; background: #BF1E2E;">
                <h5 class="modal-title" id="exampleModalLabel" style="width: 135px; height:60px"><img
                        style="height: 100%; width:100%; object-fit: cover;" src="assets/img/whiteLogo.png" alt=""></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" style="color: white;">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="background: #BF1E2E;">
                <div class="row justify-content-center">
                    <div class="col-md-6 text-center">
                        <div class="popup" (click)="navigateTo('CUSTOMER')">
                            <img src="assets/latest/customer2.png" alt="">
                        </div>
                    </div>
                    <div class="col-md-6 text-center">
                        <div class="popup" (click)="navigateTo('RETAILER')">
                            <img src="assets/latest/retailer2.png" alt="">
                        </div>
                    </div>
                    <div class="col-md-11 text-center mt-3 bg-white d-none d-md-block">
                        <div class="popup" (click)="navigateTo('SERVICE_PROVIDER')">
                            <img src="assets/latest/service.png" alt="">
                        </div>
                    </div>
                    <div class="col-12 text-center d-block d-md-none">
                        <div class="popup" (click)="navigateTo('SERVICE_PROVIDER')">
                            <img src="assets/latest/service.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>